module.exports = __webpack_public_path__ + "img/WhatsApp Image 2021-01-11 at 16.25.49.ca1b76ea.jpeg";